// Susunan searchBy/searchValue tabel PE Kasus (Fasyankes dan BKK).
// Filter tanggal hanya dikirim bila tahun terisi; tanpa tahun, kembali ke
// seluruh data fasyankes seperti tampilan awal halaman.
import moment from "moment";

export const buildPeCaseFilterParams = ({ year, month, fasyankesId }) => {
  if (!year) {
    return { searchBy: "fasyankes_id", searchValue: `${fasyankesId}` };
  }

  if (!month) {
    return {
      searchBy: "patient_visite_date|YYYY,fasyankes_id",
      searchValue: `${moment(year).year()},${fasyankesId}`,
    };
  }

  return {
    searchBy: "patient_visite_date|YYYY-MM,fasyankes_id",
    searchValue: `${moment(year).year()}-${month},${fasyankesId}`,
  };
};
